import React from "react";

/**
 * Professional Toggle Switch
 * - Smooth animation
 * - Disabled state support
 * - Accessible
 */

const CronToggleSwitch = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      {/* Track */}
      <div
        className={`
          w-11 h-6 rounded-full transition-colors duration-300
          ${checked ? "bg-green-500" : "bg-gray-300"}
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
      ></div>

      {/* Thumb */}
      <div
        className={`
          absolute left-1 top-1
          w-4 h-4 bg-white rounded-full shadow-md
          transform transition-transform duration-300
          ${checked ? "translate-x-5" : "translate-x-0"}
        `}
      ></div>
    </label>
  );
};

export default CronToggleSwitch;